import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.handleRetry = () => {
            this.setState({ hasError: false, error: undefined });
        };
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        this.props.onError?.(error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px", p: 3, children: _jsxs(Paper, { elevation: 3, sx: {
                        p: 4,
                        maxWidth: 500,
                        textAlign: 'center',
                        borderRadius: 2
                    }, children: [_jsx(ErrorOutlineIcon, { color: "error", sx: { fontSize: 64, mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "Something went wrong" }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: "An unexpected error occurred. Please try refreshing the page or contact support if the problem persists." }), process.env.NODE_ENV === 'development' && this.state.error && (_jsx(Box, { sx: {
                                p: 2,
                                bgcolor: 'grey.100',
                                borderRadius: 1,
                                mb: 3,
                                textAlign: 'left'
                            }, children: _jsx(Typography, { variant: "caption", component: "pre", sx: { fontSize: '0.75rem' }, children: this.state.error.toString() }) })), _jsx(Button, { variant: "contained", onClick: this.handleRetry, sx: { mr: 2 }, children: "Try Again" }), _jsx(Button, { variant: "outlined", onClick: () => window.location.reload(), children: "Refresh Page" })] }) }));
        }
        return this.props.children;
    }
}
